<script setup>
import ImpersonationCard from '@/Pages/DomainScore/Partials/ImpersonationCard.vue';
import PrivacyCard from '@/Pages/DomainScore/Partials/PrivacyCard.vue';
import BrandingCard from '@/Pages/DomainScore/Partials/BrandingCard.vue';
import OverallRiskCard from '@/Pages/DomainScore/Partials/OverakRiskCard.vue';
import { usePage } from '@inertiajs/vue3';

const { branding } = usePage().props;
</script>

<template>
  <div
    class="grid gap-4 px-6 sm:grid-cols-2 md:grid-cols-4 md:px-8 lg:grid-cols-6"
  >
    <div
      class="flex flex-col gap-2 pr-10 sm:col-span-2 md:col-span-4 lg:col-span-2"
    >
      <h2 class="text-xl font-bold md:text-3xl">
        {{ $t('domain_score.partials.know_your_score.know_your_score') }}
      </h2>
      <p class="text-base font-bold md:text-lg">
        {{
          $t('domain_score.partials.know_your_score.checks_dmarc_spf_dkim', {
            name: branding.name
          })
        }}
      </p>
      <p class="mb-4">
        {{ $t('domain_score.partials.know_your_score.weve_created_tool') }}
      </p>
    </div>
    <OverallRiskCard />
    <ImpersonationCard />
    <PrivacyCard />
    <BrandingCard />
  </div>
</template>
